if (window.matchMedia("(max-width: 991px)").matches) {
  // usps section
  $(document).ready(function () {
    $(".sub-usp").slick({
      slidesToShow: 3,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 576,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  });
}
